import type {Expand} from '../types';

export const questionnaireExpandCommon: Expand = {
  questionnaire: ['avatar_id'],
};

export const userQuestionnaireExpandCommon: Expand = {
  user_questionnaire: ['avatar_id'],
};
